"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const http_client_1 = __importDefault(require("../http-client"));
class AuthClient extends http_client_1.default {
    constructor() {
        super('');
        this.getCsrfCookie = () => this.instance.get('/sanctum/csrf-cookie');
        this.login = async (email, password, remember) => {
            return this.instance.post('/auth/login', { email, password, remember });
        };
        this.logout = () => this.instance.post('/auth/logout');
        this.getUser = () => {
            return this.instance.get('/api/user');
        };
    }
}
exports.default = AuthClient;
